/** Mirrors backend `Sestek.AgenticCX.Enums.NumberDisplayFormat`. */
export enum NumberDisplayFormat {
  DotThousandCommaDecimal = 1,
  CommaThousandDotDecimal = 2,
}
